import { useEffect, useRef } from "react";
import { Input } from "../ui/input";

type Props = {
  value: string;
  onChange: (v: string) => void;
  onPlaceSelect?: (place: google.maps.places.PlaceResult) => void;
  placeholder?: string;
};

export function LocationSearch({ value, onChange, onPlaceSelect, placeholder }: Props) {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);

  useEffect(() => {
    if (!inputRef.current || !window.google?.maps?.places) return;

    const options: google.maps.places.AutocompleteOptions = {
      fields: ["place_id", "name", "formatted_address"],
      types: ["(regions)"],
    };

    const ac = new window.google.maps.places.Autocomplete(inputRef.current, options);
    autocompleteRef.current = ac;

    const listener = ac.addListener("place_changed", () => {
      const place = ac.getPlace();
      if (!place) return;

      // Prefer formatted address, fallback to name
      const label = place.formatted_address || place.name || "";
      
      // Force sync to state immediately
      if (label) {
        onChange(label);
      }

      if (onPlaceSelect) onPlaceSelect(place);
    });

    return () => {
      window.google.maps.event.removeListener(listener);
    };
  }, [onChange, onPlaceSelect]);

  return (
    <Input
      ref={inputRef}
      type="text"
      placeholder={placeholder || "County, City, Town or Area"}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="pl-10 text-gray-900"
      data-testid="input-hero-location"
    />
  );
}
